/**
 * Um número em destaque, com o que ele significa embaixo.
 *
 * O componente mais simples do diretório e o que se paga na hora: a marcação ad-hoc de cartão de
 * número estava repetida em `pages/Painel.tsx`, e cada cópia tinha um tamanho de fonte diferente.
 *
 * `detalhe` existe para o número nunca aparecer sozinho. «14 cedentes» é um fato; «14 cedentes, 2
 * grupos econômicos» é uma leitura — e é a segunda que se quer numa tela de investigação.
 */
import type { ReactNode } from 'react';

export function Indicador({
  rotulo,
  valor,
  detalhe,
  alerta = false,
}: {
  rotulo: string;
  valor: ReactNode;
  detalhe?: ReactNode;
  /** Destaca em âmbar. Para o que exige atenção, nunca para o que é só grande. */
  alerta?: boolean;
}) {
  return (
    <div className="flex min-w-0 flex-col gap-0.5">
      <span className="tipo-rotulo text-text-tertiary">{rotulo}</span>
      <span
        className={`tipo-dado text-[22px] leading-tight ${alerta ? 'text-warning' : 'text-text'}`}
      >
        {valor}
      </span>
      {detalhe && <span className="tipo-corpo-pequeno text-text-secondary">{detalhe}</span>}
    </div>
  );
}
